import React from 'react'
import { NavItem, MenuItem } from 'react-bootstrap'
import { LinkContainer } from 'react-router-bootstrap'
import SubMenu from './SubMenu'

class SubMenuItem extends React.Component {
	constructor(props) {
		super(props);
		this.state = { open: false }
	}

	_handleOnClick = () => {
		if (document.createEventObject) {
			document.fireEvent('click');
		} else {
			var evt = document.createEvent("HTMLEvents");
			evt.initEvent('click', false, true);
			document.dispatchEvent(evt);
		}

		let activeDropdowns = document.querySelectorAll('.dropdown.open');
		activeDropdowns.forEach((e) => { e.classList.remove('open') });
	}

	render() {
		const { item } = this.props;

		if (item.separator) {
			return <MenuItem divider />;
		}

		if (!item.childs || !item.childs.length) {
			if (item.blankTarget)
				return (
					<li role="presentation">
						<a href={item.path} target="_blank">
							{item.text}
						</a>
					</li>);
			else
				return (
					<LinkContainer to={item.path}>
						<NavItem onClick={this._handleOnClick}>{item.text}</NavItem>
					</LinkContainer>);
		}

		return (<SubMenu
			item={item}
			isSecondLevel />
		);
	}
}

export default SubMenuItem;



// WEBPACK FOOTER //
// ./src/fw/components/menu/SubMenuItem.js